import { render, staticRenderFns } from "./climateGrids.vue?vue&type=template&id=6588de50&"
import script from "./climateGrids.vue?vue&type=script&lang=js&"
export * from "./climateGrids.vue?vue&type=script&lang=js&"
import style0 from "./climateGrids.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports